import { resolveImageSrc } from "../../api/axios";

export default function IM01({ module }) {
    const item = module.items[0] || {};

    return (
        <div className="w-full p-4">
            <section
                className="max-w-2xl mx-auto my-8 p-4 bg-white dark:bg-gray-900 rounded-lg shadow-lg"
                aria-labelledby="image-title"
            >

                {/* Titre */}
                {item.title && (
                    <h2
                        id="image-title"
                        className="text-3xl font-bold mb-4 text-gray-900 dark:text-white"
                    >
                        {item.title}
                    </h2>
                )}

                {/* Image */}
                <figure>
                    <img
                        src={resolveImageSrc(item.picture1)}
                        alt={item.alt_picture1 || ""}
                        className="rounded-lg w-full h-auto object-cover"
                    />

                    {/* figcaption = description */}
                    {item.description && (
                        <figcaption className="text-sm text-gray-600 dark:text-gray-300 mt-2">
                            {item.description}
                        </figcaption>
                    )}
                </figure>

            </section>
        </div>
    );
}
